export default {
  title: 'Informes de ingresos',
  sections: {
    new_report: 'Nuevo informe',
  },
  form: {
    period: {
      label: 'Período',
    },
  },
  buttons: {
    export: 'Exportar',
  },
  toasts: {
    failed_to_create_report: 'Error al crear el informe',
  },
};
